import React from 'react'
import { Form, Input } from 'semantic-ui-react'

import ErrorText from 'shared/components/forms/ErrorText'
import { TaxIdFieldConfig } from 'libs/tax-id-by-country'

interface TaxIdFieldProps {
  meta: TaxIdFieldConfig
  value: string
  error: string | null
  onChange: (value: string) => void
}

export function TaxIdField({ meta, value, error, onChange }: TaxIdFieldProps) {
  return (
    <Form.Field error={Boolean(error)}>
      <label htmlFor="checkout-tax-id">{meta.label}</label>
      <Input
        id="checkout-tax-id"
        placeholder={meta.placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
          if (event.key === 'Enter') {
            event.preventDefault()
          }
        }}
      />
      {error && (
        <div role="alert">
          <ErrorText>{error}</ErrorText>
        </div>
      )}
    </Form.Field>
  )
}



// WEBPACK FOOTER //
// ./src/components/TaxIdField/index.tsx